async function copyShareUrl(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const t = document.createElement('textarea');
    Object.assign(t, { value: text, readOnly: true });
    Object.assign(t.style, { position: 'fixed', opacity: '0' });
    document.body.append(t);
    t.select();
    const ok = document.execCommand('copy');
    t.remove();
    return ok;
  }
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-copy-share-url]');
  if (!btn?.dataset.copyShareUrl) return;
  e.preventDefault();
  const { copyShareUrl: url, openShareUrl, closeOnCopy } = btn.dataset;

  await copyShareUrl(url);

  if (openShareUrl) {
    window.open(openShareUrl, '_blank', 'noopener,noreferrer');
    return;
  }

  const label = btn.querySelector('.product-share__option-label');
  const orig = label?.textContent;
  if (label) {
    label.textContent = 'Link copied!';
    setTimeout(() => { if (orig) label.textContent = orig; }, 1800);
  }
  if (closeOnCopy) setTimeout(() => btn.closest('dialog-component')?.closeDialog?.(), 700);
});
